<template>
  <button :type="type" v-if="to.name == ''" class="btn" :class="[color, size]" >
    <slot />
  </button>
  <router-link v-else :to="to" class="btn" :class="[color, size]" :type="type">
    <slot />
  </router-link>
</template>

<script>
export default {
   
  props: {
    color: String,
    size: String,
    type: String,
    to: {
        type: Object,
        default: () => ({
            name: '',
        })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/components/buttons";
</style>
